module.exports = __webpack_public_path__ + "static/Step 2.5-b78ae939e7a902b11571fafa5cf5ae25.png";